export const TOGGLE_SHOWING_TUTORIAL = 'TOGGLE_SHOWING_TUTORIAL';

export function toggleShowingTutorial(showingTutorial){
    return{
        type: TOGGLE_SHOWING_TUTORIAL,
        mainState: {
            showingTutorial: showingTutorial
        }
    }
}